<template>
  <div>
    <BaseModal :showing="visible" @close="$emit('close')" @opened="loadData">
      <BaseCard title="Riwayat Status Faktur" description="Riwayat Status Faktur" :with-style="false">
        <BaseTimeline :items="data" />
      </BaseCard>
    </BaseModal>

    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';
import BaseModal from '../base/BaseModal.vue';
import BaseTimeline from '../base/BaseTimeline.vue';

export default {
  mixins: [requestMixin],
  components: { BaseModal, BaseTimeline },
  props: {
    visible: Boolean,
    orderId: String
  },
  emits: ['close'],
  data() {
    return {
      data: [],
      loading: false
    }
  },
  methods: {
    async loadData() {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/logs`,
        {
          params: {
            sort: '-id',
          },
        }
      );

      if (!err) {
        this.data = res.data.map((log) => ({
          id: log.id,
          name: log.attributes.name,
          text: log.attributes.description,
          time: log.attributes.createdAt,
        }));
      }

      this.loading = false;
    },
  }
}
</script>